import { useState } from "react";
import Button from "../../components/button";
import Datepicker from "../../components/datepicker";
import Modal from "../../components/modal";
import { getMilliSecUTC } from "../../utils/EllowUtils";

const DateEditor = (props:any) => {
  
  const [date, setDate] = useState<number>(0)
    
  const dateChange = (e:any) => {
    setDate(getMilliSecUTC(e.target.value))
  }

  const dateSubmit = () => {
    props.onSubmit(date,'date')
    props.onClose()
  }

  return (
    <Modal title="Availability" size="xsmall" onClose={props.onClose}>
      <div className="form-group">
        <label className="lablel">I’m getting relieved from my current job by </label>
        <Datepicker defaultShow={false} onChange={(e: any) => dateChange(e)} min={ new Date()} />
      </div>
      <div className="popupAction">
        <Button variant='secondary'  onClick={props.onClose}>Cancel</Button>
        <Button variant='primary' onClick={dateSubmit} >Save</Button>
      </div>
    </Modal>
  )
}

export default DateEditor